import {useEffect, useState} from "react"
import {Modal} from "../../../components/modal/Modal"
import {
    createModuleApi,
    updateModuleApi,
    updateMentorModuleApi,
    ModuleListItem,
} from "../api/modules.api"

type Props = {
    open: boolean
    onClose: () => void
    courseId: string
    module?: ModuleListItem | null
    onSaved: () => void
    /** Mentor content editing — routes the save to the narrower mentor endpoint. Edit only, mentors can't create modules. */
    isMentor?: boolean
}

export const ModuleModal = ({
                                open,
                                onClose,
                                courseId,
                                module,
                                onSaved,
                                isMentor = false,
                            }: Props) => {
    const isEdit = !!module

    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [orderNumber, setOrderNumber] = useState(0)
    const [duration, setDuration] = useState(0)

    useEffect(() => {
        if (module) {
            setTitle(module.title)
            setDescription(module.description || "")
            setOrderNumber(module.order_number)
            setDuration(module.duration_minutes)
        } else {
            setTitle("")
            setDescription("")
            setOrderNumber(0)
            setDuration(0)
        }
    }, [module])

    const handleSubmit = async () => {
        if (!title.trim()) return

        if (isEdit) {
            const payload: any = {}

            if (title !== module!.title) payload.title = title
            if (description !== module!.description) payload.description = description
            if (orderNumber !== module!.order_number) payload.order_number = orderNumber
            if (duration !== module!.duration_minutes) payload.duration_minutes = duration

            if (isMentor) {
                await updateMentorModuleApi(module!.id, payload)
            } else {
                await updateModuleApi(module!.id, payload)
            }
        } else {
            await createModuleApi({
                course_id: courseId,
                title,
                description,
                order_number: orderNumber,
                duration_minutes: duration,
            })
        }

        onSaved()
        onClose()
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={isEdit ? "Редактировать модуль" : "Добавить модуль"}
        >
            <div className="space-y-4">

                {/* ===== Title ===== */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Название модуля
                    </label>
                    <input
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="например, Введение"
                        className="w-full border rounded-lg px-3 py-2"
                    />
                </div>

                {/* ===== Description ===== */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Описание
                    </label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Короткое описание (необязательно)"
                        className="w-full border rounded-lg px-3 py-2"
                        rows={3}
                    />
                </div>

                {/* ===== Order & Duration ===== */}
                <div className="grid grid-cols-2 gap-3">

                    {/* Order */}
                    <div>
                        <label className="block text-sm font-medium mb-1">
                            Порядок в курсе
                        </label>
                        <input
                            type="number"
                            value={orderNumber}
                            onChange={(e) => setOrderNumber(Number(e.target.value))}
                            className="w-full border rounded-lg px-3 py-2"
                        />
                    </div>

                    {/* Duration */}
                    <div>
                        <label className="block text-sm font-medium mb-1">
                            Длительность (минут)
                        </label>
                        <input
                            value={duration === 0 ? "" : String(duration)}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setDuration(
                                        e.target.value === "" ? 0 : Number(e.target.value)
                                    )
                                }
                            }}
                            placeholder="например, 45"
                            className="w-full border rounded-lg px-3 py-2"
                        />
                    </div>

                </div>

                {/* ===== Actions ===== */}
                <div className="flex justify-end gap-2 pt-2">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm border rounded-lg"
                    >
                        Отмена
                    </button>

                    <button
                        onClick={handleSubmit}
                        disabled={!title.trim()}
                        className={`px-4 py-2 text-sm rounded-lg text-white
              ${!title.trim()
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700"}
            `}
                    >
                        Сохранить
                    </button>
                </div>

            </div>
        </Modal>
    )
}

